import { render, staticRenderFns } from "./FakturPajakVendorDetail.vue?vue&type=template&id=4329eabc&scoped=true"
import script from "./FakturPajakVendorDetail.vue?vue&type=script&lang=js"
export * from "./FakturPajakVendorDetail.vue?vue&type=script&lang=js"
import style0 from "./FakturPajakVendorDetail.vue?vue&type=style&index=0&id=4329eabc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4329eabc",
  null
  
)

export default component.exports